import { useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import GoogleLoginButton from './GoogleLoginButton';

const PROTECTED_PREFIXES = ['/create', '/join', '/room/', '/admin'];

function AuthStatus() {
    const { user, isAuthenticated, logout } = useAuth();
    const { pathname } = useLocation();
    const isProtectedRoute = PROTECTED_PREFIXES.some(
        (prefix) => pathname === prefix || pathname.startsWith(prefix)
    );

    if (!isAuthenticated && isProtectedRoute) {
        return null;
    }

    return (
        <div className="fixed top-4 right-4 z-50 flex items-center gap-2 sm:gap-3 bg-slate-900/95 border border-white/25 rounded-xl px-3 py-2 backdrop-blur-md shadow-xl max-w-[min(100vw-5rem,20rem)]">
            {isAuthenticated ? (
                <>
                    {user?.picture ? (
                        <img
                            src={user.picture}
                            alt=""
                            className="w-9 h-9 rounded-full ring-2 ring-primary/60 shrink-0"
                            referrerPolicy="no-referrer"
                        />
                    ) : (
                        <div
                            className="w-9 h-9 rounded-full bg-primary/30 ring-2 ring-primary/60 flex items-center justify-center text-sm font-bold text-slate-100 shrink-0"
                            aria-hidden
                        >
                            {(user?.name || user?.email || '?').charAt(0).toUpperCase()}
                        </div>
                    )}
                    <div className="min-w-0 flex-1 hidden sm:block">
                        <p className="text-sm font-semibold text-slate-50 truncate leading-tight">
                            {user?.name || 'Usuário'}
                        </p>
                        {user?.email && (
                            <p className="text-xs text-slate-400 truncate leading-tight" title={user.email}>
                                {user.email}
                            </p>
                        )}
                    </div>
                    <button
                        type="button"
                        onClick={logout}
                        className="shrink-0 rounded-lg border border-white/30 bg-white/10 px-3 py-1.5 text-sm font-semibold text-slate-50 hover:bg-white/20 hover:border-white/40 transition-colors"
                    >
                        Sair
                    </button>
                </>
            ) : (
                <GoogleLoginButton size="medium" width={200} />
            )}
        </div>
    );
}

export default AuthStatus;
